export const onRegistration = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'SNRegistration'
  });
};

export const onTrialPurchased = (email) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'SNFreeTrial'
  });
};

export const onRegularFreeTrialActions = (provider, action) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'CustomEvt',
    'eventCategory': 'SN-Auth',
    'eventAction': action,
    'eventLabel': provider
  });
};
